function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, Array, JSON, Object, String, comment, isDraggingAndDropping, isMaximized, isMinimized, isTicketSubmitted, isTicketSubmitting, isUploadingFiles, requestSubtypeLabel, requestTypeLabel, subject, uploads) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          maximized: isMaximized,
          minimized: isMinimized,
        }, {
          'support-widget-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'support-widget': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("header", {
            "on": {
              click: () => isMinimized ? $helpers.toggleMinimize() : null
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", [__vjadeSafeCode(isTicketSubmitted ? `Message sent` : `Our Support Team is ready to help!`)]));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'icon-actions': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!isMaximized && !isMinimized) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: `dash`,
                  }),
                  "on": {
                    click: $helpers.toggleMinimize,
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  elref: `toggleMaximizeButton`,
                  icon: isMaximized ? `collapse` : `expand`,
                }),
                "on": {
                  click: $helpers.toggleFullscreen,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((isTicketSubmitted) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'zendesk-ticket-submitted': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `circle-checkmark`
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'thanks': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Thanks for reaching out.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'confirmation': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(`We'll get back to you at ${$component.attr(`user-email`)} soon.`);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("footer", {
              "class": {
                'buttons': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                }),
                "on": {
                  click: $helpers.closeSupportWidget,
                },
                "class": {
                  'done': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Done");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'new-zendesk-ticket': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'form-field': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-input-label", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    label: `Request type`
                  }),
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'elref': `requestType`,
                    'options': $helpers.getRequestTypeOptions(),
                    'selected-option': requestTypeLabel || `Select request type...`,
                    'size': `large`,
                  }),
                  "on": {
                    change: ev => $helpers.selectRequestType(ev),
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              const showWarning = $helpers.showFreePlanWarning();
              __jade_nodes = __jade_nodes.concat((showWarning) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    type: `embedded`,
                    theme: `info`,
                    'body-text': $helpers.FREE_PLAN_WARNING,
                  }),
                  "class": {
                    'free-plan-warning-message': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "key": `form-fields`,
                "class": Object.assign({}, {
                  hidden: showWarning,
                }, {
                  'remaining-form-fields': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((requestTypeLabel) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'form-field': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-input-label", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        label: $helpers.getRequestSubtypeTicketField()
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'elref': `requestSubType`,
                        'options': $helpers.getRequestSubtypeOptions(),
                        'disable-search': true,
                        'selected-option': requestSubtypeLabel || `Select ${$helpers.getRequestSubtypeTicketField().toLowerCase()}...`,
                        'size': `large`,
                      }),
                      "on": {
                        change: ev => $helpers.selectRequestSubtype(ev),
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'form-field': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      label: `Subject`,
                      elref: `subjectField`,
                    }),
                    "on": {
                      input: $helpers.inputSubject
                    },
                    "props": {
                      value: subject || ``
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'form-field': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      type: `textarea`,
                      label: `How can we help?`,
                      elref: `descriptionField`,
                    }),
                    "on": {
                      input: $helpers.handleInputComment,
                      paste: $helpers.handlePasteFromClipboard,
                    },
                    "props": {
                      value: comment || ``
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'form-field': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  const numUploads = uploads.length;
                  __jade_nodes = __jade_nodes.concat(h("mp-input-label", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      label: numUploads === 0 ? `Attachments` : `Attachments (${numUploads})`,
                      necessary: `optional`,
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat((isUploadingFiles) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'uploading-file': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-spinner"));
                      __jade_nodes = __jade_nodes.concat("Uploading...");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (uploads);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, upload, i) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              'tag-name': upload.attachment.file_name,
                              removable: true,
                            }),
                            "on": {
                              remove: () => $helpers.removeUploadedFile(i)
                            },
                            "class": {
                              'uploaded-file': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var i = $$objKey;
                          if ($$obj.hasOwnProperty(i)) {
                            $$iterated = true;
                            var upload = $$obj[i];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  'tag-name': upload.attachment.file_name,
                                  removable: true,
                                }),
                                "on": {
                                  remove: () => $helpers.removeUploadedFile(i)
                                },
                                "class": {
                                  'uploaded-file': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());
                  __jade_nodes = __jade_nodes.concat(h("label", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      for: `upload-files`,
                    }),
                    "on": {
                      dragleave: $helpers.fileInputDragleave,
                      dragover: ev => $helpers.fileInputDragover(ev),
                      drop: ev => $helpers.uploadDroppedFiles(ev),
                    },
                    "class": Object.assign({}, {
                      active: isDraggingAndDropping,
                      disabled: numUploads === $helpers.MAX_FILE_UPLOADS,
                    }, {
                      'upload-files': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: `image`
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'upload-files-text': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      const uploadsRemaining = $helpers.MAX_FILE_UPLOADS - numUploads;
                      __jade_nodes = __jade_nodes.concat((numUploads === 0) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(`Add up to ${$helpers.MAX_FILE_UPLOADS} screenshots`);;
                        return __jade_nodes
                      }).call(this)) : (uploadsRemaining === 1) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(`Add up to 1 more screenshot`);;
                        return __jade_nodes
                      }).call(this)) : (numUploads < $helpers.MAX_FILE_UPLOADS) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(`Add up to ${uploadsRemaining} more screenshots`);;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(`Screenshot limit reached`);;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      accept: 'image/*',
                      type: `file`,
                      multiple: true,
                    }),
                    "hook": {
                      insert: vnode => $helpers.setElRef(`fileInput`, vnode.elm),
                    },
                    "on": {
                      input: $helpers.uploadSelectedFiles,
                    },
                    "props": {
                      id: 'upload-files'
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("footer", {
              "class": {
                'buttons': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  elref: `cancelButton`,
                  theme: `tertiary`,
                }),
                "on": {
                  click: $helpers.closeSupportWidget,
                },
                "class": {
                  'cancel-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  disabled: $helpers.isSubmitDisabled(),
                  theme: `primary`,
                }),
                "on": {
                  click: $helpers.submitZendeskTicket,
                },
                "class": {
                  'submit-button': true
                },
              }, [__vjadeSafeCode(isTicketSubmitting ? `Sending...` : `Send`)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "comment" in locals ? locals.comment : typeof comment !== "undefined" ? comment : undefined, "isDraggingAndDropping" in locals ? locals.isDraggingAndDropping : typeof isDraggingAndDropping !== "undefined" ? isDraggingAndDropping : undefined, "isMaximized" in locals ? locals.isMaximized : typeof isMaximized !== "undefined" ? isMaximized : undefined, "isMinimized" in locals ? locals.isMinimized : typeof isMinimized !== "undefined" ? isMinimized : undefined, "isTicketSubmitted" in locals ? locals.isTicketSubmitted : typeof isTicketSubmitted !== "undefined" ? isTicketSubmitted : undefined, "isTicketSubmitting" in locals ? locals.isTicketSubmitting : typeof isTicketSubmitting !== "undefined" ? isTicketSubmitting : undefined, "isUploadingFiles" in locals ? locals.isUploadingFiles : typeof isUploadingFiles !== "undefined" ? isUploadingFiles : undefined, "requestSubtypeLabel" in locals ? locals.requestSubtypeLabel : typeof requestSubtypeLabel !== "undefined" ? requestSubtypeLabel : undefined, "requestTypeLabel" in locals ? locals.requestTypeLabel : typeof requestTypeLabel !== "undefined" ? requestTypeLabel : undefined, "subject" in locals ? locals.subject : typeof subject !== "undefined" ? subject : undefined, "uploads" in locals ? locals.uploads : typeof uploads !== "undefined" ? uploads : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;